import { fetchToken } from '../../../services/authService'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchData = createAsyncThunk('data/fetchData', fetchToken)

